<template>
  <div class="crm-page">
    <div class="crm-hero">
      <div>
        <div class="crm-eyebrow">客户管理CRM</div>
        <h2>客户分析</h2>
        <p>
          聚合展示员工通话量、加微信率、来源渠道转化率、流失原因与意向等级分布，先用
          mock 图表演示分析看板。
        </p>
      </div>
      <div class="crm-actions">
        <el-radio-group v-model="range" size="small">
          <el-radio-button label="today">今日</el-radio-button>
          <el-radio-button label="week">本周</el-radio-button>
          <el-radio-button label="month">本月</el-radio-button>
        </el-radio-group>
        <el-button icon="el-icon-download" @click="notifyPending"
          >导出分析报表（待开发）</el-button
        >
      </div>
    </div>

    <div class="metric-grid">
      <div class="metric-card">
        <span>公海池转化率</span>
        <strong>38%</strong>
      </div>
      <div class="metric-card">
        <span>跟进及时率</span>
        <strong>82%</strong>
      </div>
      <div class="metric-card">
        <span>超期率</span>
        <strong>11%</strong>
      </div>
      <div class="metric-card">
        <span>成交率</span>
        <strong>16%</strong>
      </div>
    </div>

    <el-row :gutter="16">
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header">员工通话量排行</div>
          <div ref="callRank" class="chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header">加微信率排行</div>
          <div ref="wechatRank" class="chart-box"></div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="16" style="margin-top: 16px">
      <el-col :span="8">
        <el-card shadow="never">
          <div slot="header">来源渠道转化率</div>
          <div ref="source" class="chart-box small"></div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never">
          <div slot="header">客户状态分布</div>
          <div ref="status" class="chart-box small"></div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never">
          <div slot="header">意向等级分布</div>
          <div ref="intention" class="chart-box small"></div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="16" style="margin-top: 16px">
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header">流失原因分布</div>
          <div ref="lostReason" class="chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header">分析说明</div>
          <div class="analysis-note">
            <p>
              1. 当前图表全部使用 mock
              数据展示，便于先确认经营口径、指标名称和布局结构。
            </p>
            <p>
              2.
              第二阶段建议接入员工维度的通话、跟进、加微信、签约、回款等聚合接口。
            </p>
            <p>
              3. 这里预留了报表导出入口，后续可以接导出 Excel / PDF / 截图报告。
            </p>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { loadCrmState } from "./mock";

export default {
  name: "CrmAnalysis",
  data() {
    return {
      range: "today",
      state: loadCrmState(this.$store.getters.GET_TITLE || "当前员工"),
      chartMap: {},
    };
  },
  computed: {
    statusDist() {
      const map = {};
      (this.state.customers || []).forEach((item) => {
        map[item.mainStatus] = (map[item.mainStatus] || 0) + 1;
      });
      return Object.keys(map).map((key) => ({ name: key, value: map[key] }));
    },
    intentionDist() {
      const map = {};
      (this.state.customers || []).forEach((item) => {
        map[item.intentionLevel] = (map[item.intentionLevel] || 0) + 1;
      });
      return Object.keys(map).map((key) => ({ name: key, value: map[key] }));
    },
  },
  mounted() {
    this.renderCharts();
  },
  beforeDestroy() {
    Object.keys(this.chartMap).forEach((key) => {
      this.chartMap[key] && this.chartMap[key].dispose();
    });
  },
  methods: {
    notifyPending() {
      this.$message.warning("分析报表导出为预留功能，待二阶段接真实数据。");
    },
    getChart(key) {
      if (!this.chartMap[key] && this.$refs[key]) {
        this.chartMap[key] = echarts.init(this.$refs[key]);
      }
      return this.chartMap[key];
    },
    renderCharts() {
      this.$nextTick(() => {
        this.renderCallRank();
        this.renderWechatRank();
        this.renderSource();
        this.renderStatus();
        this.renderIntention();
        this.renderLostReason();
      });
    },
    renderCallRank() {
      const chart = this.getChart("callRank");
      const data = this.state.analysisSeries.employeeCallRank || [];
      if (!chart) return;
      chart.setOption({
        tooltip: { trigger: "axis" },
        xAxis: {
          type: "category",
          data: data.map((item) => item.name),
          axisLabel: { color: "#6b7280" },
        },
        yAxis: { type: "value", axisLabel: { color: "#6b7280" } },
        series: [
          {
            type: "bar",
            data: data.map((item) => item.value),
            barWidth: 26,
            itemStyle: { color: "#409eff", borderRadius: [8, 8, 0, 0] },
          },
        ],
      });
    },
    renderWechatRank() {
      const chart = this.getChart("wechatRank");
      const data = this.state.analysisSeries.addWechatRank || [];
      if (!chart) return;
      chart.setOption({
        tooltip: { trigger: "axis" },
        xAxis: { type: "value", axisLabel: { color: "#6b7280" } },
        yAxis: {
          type: "category",
          data: data.map((item) => item.name),
          axisLabel: { color: "#6b7280" },
        },
        series: [
          {
            type: "bar",
            data: data.map((item) => item.value),
            barWidth: 18,
            itemStyle: { color: "#34d399", borderRadius: 10 },
          },
        ],
      });
    },
    renderSource() {
      const chart = this.getChart("source");
      if (!chart) return;
      chart.setOption({
        tooltip: { trigger: "item" },
        legend: { bottom: 0 },
        series: [
          {
            type: "pie",
            radius: ["42%", "68%"],
            data: this.state.analysisSeries.conversionBySource || [],
          },
        ],
      });
    },
    renderStatus() {
      const chart = this.getChart("status");
      if (!chart) return;
      chart.setOption({
        tooltip: { trigger: "item" },
        series: [
          {
            type: "pie",
            radius: "68%",
            data: this.statusDist,
            label: { formatter: "{b}\n{d}%" },
          },
        ],
      });
    },
    renderIntention() {
      const chart = this.getChart("intention");
      if (!chart) return;
      chart.setOption({
        tooltip: { trigger: "item" },
        series: [
          {
            type: "pie",
            radius: "68%",
            data: this.intentionDist,
            label: { formatter: "{b}\n{d}%" },
          },
        ],
      });
    },
    renderLostReason() {
      const chart = this.getChart("lostReason");
      if (!chart) return;
      chart.setOption({
        tooltip: { trigger: "axis" },
        xAxis: {
          type: "category",
          data: (this.state.analysisSeries.lostReasonDist || []).map(
            (item) => item.name
          ),
          axisLabel: { color: "#6b7280" },
        },
        yAxis: { type: "value", axisLabel: { color: "#6b7280" } },
        series: [
          {
            type: "line",
            smooth: true,
            data: (this.state.analysisSeries.lostReasonDist || []).map(
              (item) => item.value
            ),
            itemStyle: { color: "#fb7185" },
            areaStyle: { color: "rgba(251,113,133,0.16)" },
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.crm-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.crm-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 24px 28px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.04);
}
.crm-eyebrow {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  font-size: 12px;
  font-weight: 700;
}
.crm-hero h2 {
  margin: 12px 0 0;
  font-size: 28px;
  color: #111827;
}
.crm-hero p {
  margin: 10px 0 0;
  color: #6b7280;
  line-height: 1.7;
}
.crm-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.metric-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}
.metric-card {
  padding: 18px 20px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #e8edf5;
}
.metric-card span {
  color: #6b7280;
}
.metric-card strong {
  display: block;
  margin-top: 10px;
  font-size: 32px;
  color: #111827;
}
.chart-box {
  height: 320px;
}
.chart-box.small {
  height: 280px;
}
.analysis-note {
  color: #4b5563;
  line-height: 1.9;
}
@media (max-width: 1200px) {
  .crm-hero {
    flex-direction: column;
    align-items: flex-start;
  }
  .metric-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
